import React, { Fragment, Component } from 'react'
import {
    Container,
    Row, Col,
    CardBody, Card, CardTitle,
    Button,
    Fieldset, Legend, Label, Input, Table,
    Nav,
    NavItem,
    NavLink,
    TabContent,
    TabPane,
} from "reactstrap"
import classnames from "classnames"
import { ConfirmAlert } from '../../../../../helpers/ui/alert'
import { accessRole } from '../../../../../helpers/access_role'
import Select from '../../../../../helpers/ui/CustomSelect'
import { AvForm, AvField } from "availity-reactstrap-validation"

import { Link, Redirect } from "react-router-dom"
import Shimmer from "react-shimmer-effect";

import apiResponse from '../../../../../services/apiResponse'
import { cancelToken } from '../../../../../services/adapters/kepegawaian/menuService'

import IndexBloc from '../Index/Blocs/IndexBloc'
import RevokeBloc from './Blocs/RevokeBloc'

const satuanWaktu = [
    { value: 'Hari', label: 'Hari'},
    { value: 'Minggu', label: 'Minggu'},
    { value: 'Bulan', label: 'Bulan' },
]

const reformatDate = (date, withDay = false) => {
    const months = [
        "Januari",
        "Februari",
        "Maret",
        "April",
        "Mei",
        "Juni",
        "Juli",
        "Agustus",
        "September",
        "Oktober",
        "November",
        "Desember",
    ];
    const days = [
        "Minggu",
        "Senin",
        "Selasa",
        "Rabu",
        "Kamis",
        "Jum'at",
        "Sabtu"
    ]
    
    const d = new Date(date);

    let dt = d.getDate()
    if (dt < 10)
        dt = '0'+dt

    let day = ''
    if (withDay) {
        day = days[d.getDay()] + ", "
    }

    if (date) {
        return day + dt + " " + months[d.getMonth()] + " " + d.getFullYear();
    }

    return '-'
};

class DetailView extends Component {

    // Retrieve Data Pegawai by Admin / Pegawai
    userdata = JSON.parse(localStorage.getItem('userdata'));
    employeeSeleted = JSON.parse(localStorage.getItem('employeeSelected'));
    peg_uuid = !accessRole('approve') ? (this.userdata != null ? this.userdata.employee_uuid : "") 
    : (this.employeeSeleted != null ? this.employeeSeleted.employee_uuid : "")

    source
    indexBloc = new IndexBloc()
    revokeBloc = new RevokeBloc()
    timer

    constructor(props) {
        super(props)
        this.state = {
            detail: null,
            activeTab: "1",
            typeOption: [],
            signatoriesOption: [],
            kuota: [],
            pembatalan: [],
            approval: null,
            typeFilter: {
                filter_value: "",
                page_number: 1,
                page_size: 50,
                sort_order: {
                    column: 'paid_leave_type_id',
                    order: 'asc' 
                }
            },
            signatoriesFilter: {
                filter_value: "",
                page_number: 1,
                page_size: 50,
                sort_order: {
                    column: 'signatories_official_id',
                    order: 'asc' 
                }
            } 
        }
    }

    toggle = (tab) => {
        if (this.state.activeTab !== tab) {
            this.setState({ activeTab: tab })
        }
    }

    handlerOnSubmit = (e, values) => {
        this.setState({
            dataForm: {
              uuid: this.props.uuid,
              approval: this.state.approval,
              ...values
            },
            confirm: true
        })
    }

    submitData = async () => {
        await this.revokeBloc.fetchRevoke(this.state.dataForm)
    }


    confirmResponse = (response) => {
        let forState = {}

        switch(response) {
            case 'cancel':
                forState = {
                    confirm: false
                }
                break;
            case 'confirm':
                forState = {
                    loading: true,
                    confirm: false
                }
                this.submitData()
                break;
            case 'success':
                forState = {
                    success: false,
                    redirect: true
                }
                break;
             case 'failed':
                forState = {
                    failed: false
                }
                break;
            default:       
        }
        this.setState(forState)
    }




    loadSignatoriesList = async () => {
        let offset = (this.state.signatoriesFilter.page_number-1)*this.state.signatoriesFilter.page_size
        const query = {
            search: this.state.signatoriesFilter.filter_value,
            limit: this.state.signatoriesFilter.page_size,
            offset: offset,
            order: this.state.signatoriesFilter.sort_order.column,
            sort: this.state.signatoriesFilter.sort_order.order,
            status: 1
        }
        await this.indexBloc.fetchSignatoriesList(query, this.source.token)
    }

    loadTypeList = async () => {
        let offset = (this.state.typeFilter.page_number-1)*this.state.typeFilter.page_size
        const query = {
            search: this.state.typeFilter.filter_value,
            limit: this.state.typeFilter.page_size,
            offset: offset,
            order: this.state.typeFilter.sort_order.column,
            sort: this.state.typeFilter.sort_order.order,
            status: 1
        }
        await this.indexBloc.fetchTypeList(query, this.source.token)
    }

    loadDetail = async () => {
        const query = { 
            uuid: this.props.uuid
        }
        await this.indexBloc.fetchDetail(query, this.source.token)
    }

    loadKuota = async (employee_uuid) => {
        await this.indexBloc.fetchKuotaTahunan({ uuid: employee_uuid })
    }

    cekWaktuCuti = (detail) => {
        const presensi = detail?.presensi
        let ketersediaan = []
        if (presensi) {
            presensi.forEach(element => {
                if (element.presensi_time_in != null || element.presensi_time_out != null) {
                    ketersediaan.push(element)
                }
            });
        }
        this.setState({ pembatalan: ketersediaan })
    }

    setTokenAPI = () => {
        if (typeof this.source != typeof undefined) {
            this.source.cancel();
        }
        this.source = cancelToken()
        this.loadTypeList()
        this.loadSignatoriesList()
        this.loadDetail()
        // this.loadKuota()
    }

    handleSelectInputChange = value => {
        clearTimeout(this.timer)

        this.state.signatoriesFilter.filter_value = value

        this.timer = setTimeout(() => this.loadSignatoriesList(), 800);
    }

    componentDidMount = () => {
        this.setTokenAPI()

        // this.indexBloc.kuotaChannel.subscribe((result) => {
        //     switch (result.status) {
        //         case apiResponse.COMPLETED:
        //             this.setState({ kuota: result.data.response })
        //             break;
        //         case apiResponse.ERROR:
        //             break;
        //         default:
        //             break;
        //     }
        // })

        this.revokeBloc.revokeChannel.subscribe((result) => {
            switch (result.status) {
                case apiResponse.COMPLETED:
                    this.setState({
                        loading: false,
                        success: true,
                    });
                    break
                case apiResponse.ERROR:
                    this.setState({
                        loading: false,
                        failed: true,
                    });
                    break
                default:
                    break
            }
        })

        this.indexBloc.detailChannel.subscribe((result) => {
            switch (result.status) {
                case apiResponse.COMPLETED:
                    this.setState({ detail: result.data.response })
                    if (result.data.response?.paid_leave_approval_status) {
                        this.cekWaktuCuti(result.data.response)
                    }
                    if (result.data.response?.paid_leave_employee_uuid) {
                        this.loadKuota(result.data.response?.paid_leave_employee_uuid)
                    }
                    break;
                default:
                    break;
            }
        })

        this.indexBloc.typeChannel.subscribe((result) => {
            switch (result.status) {
                case apiResponse.COMPLETED:
                    this.setState({ typeOption: result.data.response.result })
                    break;
                case apiResponse.ERROR:
                    break;
                default:
                    break;
            }
        })

        this.indexBloc.signatoriesChannel.subscribe((result) => {
            switch (result.status) {
                case apiResponse.COMPLETED:
                    this.setState({ signatoriesOption: result.data.response })
                    break;
                case apiResponse.ERROR:
                    break;
                default:
                    break;
            }
        })

    }

    componentWillUnmount = () => {
        // this.indexBloc.kuotaChannel?.unsubscribe()
        this.indexBloc.cancelChannel?.unsubscribe()
        this.indexBloc.detailChannel?.unsubscribe()
        this.indexBloc.typeChannel?.unsubscribe()
        this.indexBloc.signatoriesChannel?.unsubscribe()
        this.revokeBloc.revokeChannel?.unsubscribe()
    }

    render() {
        const { detail } = this.state
        // let sisaCutiTahunIni = 0;
        // if (this.state.kuota) {
        //     let sisaCuti = 0;
        //     sisaCuti = (this.state.kuota?.oneYearBefore > 6 ? 6 : this.state.kuota?.oneYearBefore) + (this.state.kuota?.twoYearBefore > 6 ? 6 : this.state.kuota?.twoYearBefore)
        //     if (sisaCuti > 6) {
        //         sisaCuti = 6
        //     }
        //     sisaCutiTahunIni = this.state.kuota?.yearNow + sisaCuti;
        //     if (sisaCutiTahunIni < 0) {
        //         sisaCutiTahunIni = 0
        //     }
        // }
        let isAvailable = 0
        return (
            <Fragment>
                <Container fluid>
                    <Row>
                        <Col md="12">
                            <Card>
                                <CardBody>
                                    <div className="float-end">
                                        { detail?.paid_leave_approval_status == 1 &&
                                            <Button style={{ marginRight: 5 }} color="danger" onClick={() => this.handlerOnSubmit()}><i className="uil uil-user-times"></i> Pengajuan Pembatalan</Button>
                                        }
                                        <Link to={`/izinpegawai/cuti.html`}>
                                            <Button outline color="primary"><i className="uil uil-backward"></i> Kembali</Button>
                                        </Link>
                                    </div>
                                    <CardTitle>Detail Pembatalan Cuti</CardTitle>
                                    <hr />
                                    <Nav tabs>
                                        <NavItem>
                                            <NavLink
                                                style={{ cursor: "pointer" }}
                                                className={classnames({
                                                    active: this.state.activeTab === "1",
                                                })}
                                                onClick={() => {
                                                    this.toggle("1")
                                                }}
                                            >
                                                <span className="d-block d-sm-none"><i className="fas fa-home"></i></span>
                                                <span className="d-none d-sm-block">Detail</span>
                                            </NavLink>
                                        </NavItem>
                                        <NavItem>
                                            <NavLink
                                                style={{ cursor: "pointer" }}
                                                className={classnames({
                                                active: this.state.activeTab === "2",
                                                    })}
                                                onClick={() => {
                                                    this.toggle("2")
                                                }}
                                            >
                                                <span className="d-block d-sm-none"><i className="far fa-envelope"></i></span>
                                                <span className="d-none d-sm-block">Pembatalan Cuti</span>
                                            </NavLink>
                                        </NavItem>
                                    </Nav>
                                    <TabContent activeTab={this.state.activeTab} className="p-3 text-muted">
                                        <TabPane tabId="1">
                                            <Row className="mb-3">
                                                <Label
                                                    className="col-md-2 col-form-label"
                                                >
                                                    Jenis Cuti
                                                </Label>
                                                { detail != null ?
                                                    <Label className="col-md-2 col-form-label">{detail?.paid_leave_type_full_name}</Label>       
                                                    :
                                                    <div className="col-md-5 col-form-label">
                                                        <Shimmer><div style={{width: '100%', height: 20}}></div></Shimmer>
                                                    </div>
                                                }
                                            </Row>

                                            { detail?.paid_leave_type_uuid == '2472b11b-6e1d-4f53-a49c-7c13d6477cb7' &&
                                                <Row className="mb-3">
                                                    <Label
                                                        className="col-md-2 col-form-label"
                                                    >
                                                    </Label>
                                                    { detail != null ?
                                                        <Label className="col-md-2 col-form-label">{detail?.paid_leave_category == 1 ? 'Rawat Inap' : 'Rawat Jalan'}</Label>       
                                                        :
                                                        <div className="col-md-5 col-form-label">
                                                            <Shimmer><div style={{width: '100%', height: 20}}></div></Shimmer>
                                                        </div>
                                                    }
                                                </Row>
                                            }

                                            <Row className="mb-3">
                                                <Label
                                                    className="col-md-2 col-form-label"
                                                >
                                                    Tanggal Mulai Cuti
                                                </Label>
                                                { detail != null ?
                                                    <Label className="col-md-2 col-form-label">{reformatDate(detail?.paid_leave_start_date)}</Label>       
                                                    :
                                                    <div className="col-md-5 col-form-label">
                                                        <Shimmer><div style={{width: '100%', height: 20}}></div></Shimmer>
                                                    </div>
                                                }
                                            </Row>

                                            <Row className="mb-3">
                                                <Label
                                                    className="col-md-2 col-form-label"
                                                >
                                                    Tanggal Selesai Cuti
                                                </Label>
                                                { detail != null ?
                                                    <Label className="col-md-2 col-form-label">{reformatDate(detail?.paid_leave_end_date)}</Label>       
                                                    :
                                                    <div className="col-md-5 col-form-label">
                                                        <Shimmer><div style={{width: '100%', height: 20}}></div></Shimmer>
                                                    </div>
                                                }
                                            </Row>

                                            <Row className="mb-3">
                                                <Label
                                                    className="col-md-2 col-form-label"
                                                >
                                                    Alasan Cuti
                                                </Label>
                                                { detail != null ?
                                                    <Label className="col-md-2 col-form-label">{detail?.paid_leave_reason}</Label>       
                                                    :
                                                    <div className="col-md-5 col-form-label">
                                                        <Shimmer><div style={{width: '100%', height: 20}}></div></Shimmer>
                                                    </div>
                                                }
                                            </Row>

                                            <Row className="mb-3">
                                                <Label
                                                    className="col-md-2 col-form-label"
                                                >
                                                    Alamat Selama Menjalankan Cuti
                                                </Label>
                                                { detail != null ?
                                                    <Label className="col-md-2 col-form-label">{detail?.paid_leave_address}</Label>       
                                                    :
                                                    <div className="col-md-5 col-form-label">
                                                        <Shimmer><div style={{width: '100%', height: 20}}></div></Shimmer>
                                                    </div>
                                                }
                                            </Row>

                                            <Row className="mb-3">
                                                <Label
                                                    className="col-md-2 col-form-label"
                                                >
                                                    No Telepon Selama Cuti
                                                </Label>
                                                { detail != null ?
                                                    <Label className="col-md-2 col-form-label">{detail?.paid_leave_address}</Label>       
                                                    :
                                                    <div className="col-md-5 col-form-label">
                                                        <Shimmer><div style={{width: '100%', height: 20}}></div></Shimmer>
                                                    </div>
                                                }
                                            </Row>

                                        </TabPane>
                                        <TabPane tabId="2">
                                            <CardTitle>Pembatalan Cuti</CardTitle>
                                            <br/>
                                            <Label>Detail Tanggal :</Label>
                                            <AvForm
                                                className="needs-validation"
                                                onValidSubmit={(e, values) => this.handlerOnSubmit(e, values)}
                                            >
                                                <Table className='table-striped table-bordered'>
                                                    <thead>
                                                        <tr>
                                                            <th style={{ width: '50px' }}>No</th>
                                                            <th>Hari, Tanggal</th>
                                                            <th>Status</th>
                                                        </tr>
                                                    </thead>
                                                    <tbody>
                                                    { detail ? 
                                                        detail?.details?.map((val, i) => {
                                                            if (val.paid_leave_detail_status == 3) {
                                                                isAvailable += 1 
                                                            }
                                                            return (
                                                                <tr>
                                                                    <td className="text-center">{i + 1}</td>
                                                                    <td>{reformatDate(val.paid_leave_detail_date, true)}</td>
                                                                    <td>{val.paid_leave_detail_status_name}</td>
                                                                </tr>
                                                            )
                                                        })
                                                        : 
                                                        <tr>
                                                            <td colSpan={2}>
                                                                <Shimmer>
                                                                    <div style={{ width: "400px", height: "16px", alignSelf: "center", borderRadius: "8px", 
                                                                                marginTop: 'calc(0.47rem + 1px)', marginBottom: 'calc(0.47rem + 1px)', fontSize: 'inherit', lineHeight: '1.5' }} />
                                                                </Shimmer>
                                                            </td>
                                                        </tr>
                                                    }
                                                    </tbody>
                                                </Table>       
                                                <div className="float-end">
                                                    <Button color="danger" style={{ marginRight: 5 }} onClick={() => { 
                                                        this.setState({ approval: 0 })
                                                    }} type="submit">
                                                        Tolak Pembatalan Cuti
                                                    </Button>
                                                    { isAvailable > 0 &&
                                                        <Button color="primary" onClick={() => {
                                                            this.setState({ approval: 1 })
                                                        }} type="submit">
                                                            Setujui Pembatalan Cuti
                                                        </Button>
                                                    }
                                                </div>
                                            </AvForm>
                                        </TabPane>
                                    </TabContent>

                                </CardBody>
                            </Card>
                        </Col>
                    </Row>
                </Container>


                <ConfirmAlert
                    confirmTitle="Konfirmasi!"
                    confirmInfo="Apakah anda yakin keputusan tersebut sudah benar?"

                    loadingTitle="Mengirim data..."
                    loadingInfo="Tunggu beberapa saat"

                    successTitle="Berhasil!"
                    successInfo="Data berhasil disimpan"

                    failedTitle="Gagal!"
                    failedInfo="Data gagal disimpan"

                    showConfirm={this.state.confirm}
                    showLoading={this.state.loading}
                    showSuccess={this.state.success}
                    showFailed={this.state.failed}

                    response={this.confirmResponse}
                />
                { this.state.redirect ?
                    <Redirect to={'/izinpegawai/cuti.html'} />
                : null }



            </Fragment>
        )
    }

}

export default DetailView 